export default __webpack_public_path__ + "static/media/offSite.34617d5d.svg";